export default "__VITE_ASSET__BLCXGWce__"